import { PageHeader } from '@/shared/components/PageHeader';
import { Briefcase } from 'lucide-react';
import AssignTasksStep from '../components/AssignTasksStep';

export default function CategoryTasksPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Category Tasks"
        subtitle="Assign and manage tasks within job categories"
        icon={<Briefcase className="w-7 h-7" style={{ color: '#E84A2B' }} />}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <AssignTasksStep />
      </div>
    </div>
  );
}
